export const MOBILE_WIDTH: number = 10000; // px

export const ORDERBOOK_LEVELS: number = 25; // rows count